function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71 4.54C2.32 4.15 2.32 3.52 2.71 3.13C3.1 2.74 3.74 2.74 4.13 3.13L20.44 19.46C20.83 19.85 20.83 20.48 20.44 20.87C20.05 21.26 19.42 21.26 19.03 20.87L16.31 18.15C14.97 18.67 13.52 18.97 12 18.97C7 18.97 2.73 15.86 1 11.47C1.77 9.5 3.06 7.8 4.68 6.51L2.71 4.54ZM17 11.47C17 8.71 14.76 6.47 12 6.47C11.49 6.47 11 6.57 10.53 6.71L8.36 4.54C9.51 4.17 10.73 3.97 12 3.97C17 3.97 21.27 7.08 23 11.46C22.31 13.22 21.21 14.76 19.82 15.99L16.76 12.93C16.9 12.47 17 11.98 17 11.47ZM12 16.47C9.24 16.47 7 14.23 7 11.47C7 10.7 7.18 9.97 7.49 9.33L9.06 10.9C9.03 11.08 9 11.27 9 11.47C9 13.13 10.34 14.47 12 14.47C12.2 14.47 12.38 14.44 12.57 14.4L14.14 15.97C13.49 16.29 12.77 16.47 12 16.47ZM14.97 11.14C14.82 9.74 13.72 8.65 12.33 8.5L14.97 11.14Z",
    fill: "#9da3a8"
  }));
};
export default SvgComponent;
//# sourceMappingURL=visibility_off.js.map